/**
 * Rinnovo della sessione indipendente dalla modalità di login: refresh token dell'IdP OIDC di
 * sviluppo (oidc.ts) oppure sessione Microsoft Entra ID (entra.ts, TC_AUTH_PROVIDER=entra).
 */
import { refreshSession } from './oidc.js';
import { renewEntraSession } from './entra.js';
import { OIDC_ISSUER } from './oidcConfig.js';
import { getAuthMode, getRefreshToken } from './tokenStore.js';

/** True se il token corrente si può rinnovare senza rimandare l'utente al login. */
export function hasRenewableSession(): boolean {
  if (getAuthMode() === 'entra') return true;
  return Boolean(OIDC_ISSUER) && getRefreshToken() !== null;
}

/** Nuovo token, o null se non rinnovabile / rinnovo fallito. Non lancia mai. */
export function renewSession(): Promise<string | null> {
  if (getAuthMode() === 'entra') return renewEntraSession();
  if (OIDC_ISSUER && getRefreshToken()) return refreshSession(OIDC_ISSUER);
  return Promise.resolve(null);
}
